import React, { useState } from 'react';
import './Contact.css';
import { Mail, Phone, MapPin } from 'lucide-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        fetch('https://contact.hamzaekhwan.com/api/contact/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                if (response.ok) {
                    toast.success('Your message has been sent successfully!');
                    setFormData({ name: '', email: '', message: '' });
                } else {
                    toast.error('There was a problem sending your message. Please try again.');
                }
            })
            .catch(error => {
                console.error('Error sending message:', error);
                toast.error('An unexpected error occurred. Please try again later.');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <section id="contact" className="container">
            <div className="section-header">
                <h2 className="section-title">Contact Me</h2>
                <p className="section-subtitle">Let's get in touch</p>
            </div>

            <div className="contact-container">
                <div className="contact-info">
                    <h3>Get in Touch</h3>
                    <p>
                        I am open to freelance opportunities, collaborations, or just a friendly chat.
                        Feel free to reach out!
                    </p>
                    <ul className="contact-methods">
                        <li><Mail size={16} /> hamzaekhwan2000@gmail.com</li>
                        <li><Phone size={16} /> +963952347334 / +971506899548</li>
                        <li><MapPin size={16} /> Syria, Homs</li>
                    </ul>
                </div>

                <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="name">Name</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Your name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Your email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="message">Message</label>
                        <textarea
                            id="message"
                            name="message"
                            rows="5"
                            placeholder="Your message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                        ></textarea>
                    </div>
                    <button type="submit" className="submit-btn" disabled={loading}>
                        {loading ? 'Sending...' : 'Send Message'}
                    </button>
                </form>
            </div>

            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </section>
    );
};

export default Contact;
